import { DataBean } from "../DataBean";

export class WelfareEntity extends DataBean {

    public async getWelfareEntityCatalogByType(type:any,idWelfareEntityType:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getWelfareEntityCatalogByType_Number_Number_String_Number_Number", [type,idWelfareEntityType,regexStr,page,recordsPerPage]);
    }

    public async importWelfareEntity(idEmployee : number , media : string, mediaContext:string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_importWelfareEntity_Number_String_String", [idEmployee, media, mediaContext]);
    }
 
}